import React from "react";
import { Switch, Route, BrowserRouter as Router } from "react-router-dom";
import { useSelector } from "react-redux";
import Login from "../components/Authorization/Login/Login";
import LoadingPage from "../Pages/LoadingPage";
import AuthenticatedRoutes from "./AuthenticatedRoutes";


function Routes({ loading }) {
  const { user, isAuthenticated } =
    useSelector((state) => state.auth);
    
  if (loading) {
    return (
      <Router>
        <Switch>
          <Route exact path="*" component={LoadingPage} />
        </Switch>
      </Router>
    );
  }

  if (!isAuthenticated) {
    return (
      <Router>
        <Switch>
          <Route exact path="/sign_in" component={Login} />
          <Route exact path="*" component={Login} />
        </Switch>
      </Router>
    );
  }

  return <AuthenticatedRoutes user={user} />;
}

export default Routes;
